import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import jsPDF from "jspdf";
import "jspdf-autotable";

import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter } from "@tabler/icons-react";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import {
  getCompanys,
  getDepartments,
  getEmpLeaveRequest,
  getEmployee,
  GetLeavsAllemployesss,
  GetNoOfLeaveWithDate,
  GetPendingLeave,
  InsertEmpLeavreqByUser,
  leaverequeststatuschange,
  insertEmpLeaveRequestadminWeeklyOff,
  recallleaverequest,
  GetOtherLeaves,
  ProcessEmpLeaveALL,
  getServiceRequest,
  changeRequestStatus,
  GetLastWeekOff,
} from "../../services/dataService";
import Select from "react-select";
import { IMAGE_URL } from "../../services/apiGateway";
import { Link } from "react-router-dom";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";
function LeaveRequest() {
  const UID = getSecureItem("userId");
  const isAdmina = getSecureItem("IsAdmin");
  const departmentName = getSecureItem("DepartmentName");

  const UserType = getSecureItem("UserType");

  // const userDepartmentId = getSecureItem("DepartmentId");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const userDepartmentId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const [moadaopen, setmoadaopen] = useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const [companyDetails, setCompanyDetails] = useState([]);
  const [editLeaveModal, seteditLeaveModal] = useState(false);
  const [finalData, setfinaldata] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [addLeaveRequestModal, setAddLeaveRequestModal] = useState(false);
  const [otherLeaves, setOtherLeaves] = useState([]);
  const [permissionsData, setPermissionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [department, setDepartment] = useState([]);
  const [date, setDate] = useState("");
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [NoofDays, setNoofDays] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pendingleave, setPendingleave] = useState([]);
  const [allEmpLeaveReq, setAllEmpLeaveReq] = useState([]);
  const [lastWeekOff, setLastWeekOff] = useState([]);

  const [leaveRequestData, setLeaveRequestData] = useState({
    Id: "",
    EmpId: "", // Employee ID
    EmpName: "", // Employee Name
    selectedLeaveType: "", // Selected Leave Type
    FromDate: "", // From Date
    ToDate: "", // To Date
    NoOfDays: "", // Number of Days
    Reason: "", // Reason for Leave
    Status: 0,
    DepartmentId: "",
    Medical: "",
  });

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Extract the date part
  };
  // Function to calculate the maximum number of days
  const calculateMaxDays = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 0; // Return 0 if dates are not provided
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffInMs = to - from; // Difference in milliseconds
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24)); // Convert to days
    return diffInDays + 1; // Ensure at least 1 day
  };

  const handleChnagePermissionStatus = async (row, action) => {
    const data = {
      UserId: UID,
      UserRemarks: "",
      Status: action === "approve" ? "1" : "2",
      EmpId: row.EmpId,
      Id: row.Id,
    };

    try {
      const response = await changeRequestStatus(data);
      toast.success(
        `Request ${
          action === "approve" ? "approved" : "rejected"
        } successfully!`
      );

      // Fetch updated service requests
      const updatedPermissions = await fetchServiceReq();
    } catch (error) {
      console.error("Error changing request status:", error);
      toast.error("Error updating request status. Please try again.");
    }
  };

  const handlerecall = (data) => {
    const Payload = {
      Id: data.Id,
    };
    const response = recallleaverequest(Payload);
    if (response) {
      toast.success("Leave Request Recalled Successfully");
      fetchAllEmpLeaveReq();
    }
  };
  const empOptionForLeave =
    isAdmina == 0
      ? employee
          .filter((el) => el.DepartmentId === userDepartmentId)
          .map((el) => ({ value: el.Id, label: el.Name }))
      : employee
          .filter((el) => el.DepartmentId === leaveRequestData.DepartmentId)
          .map((el) => ({ value: el.Id, label: el.EmployeeNameWithCode }));

  const calculateDays = (fromDate, toDate) => {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffTime = Math.abs(to - from);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Department logic
    if (name === "DepartmentId") {
      const depIds = value.split(","); // In case it's multiple IDs
      const selectedDepNames = department
        .filter((el) => depIds.includes(el.Id)) // Match selected IDs
        .map((el) => el.Name?.toLowerCase());

      const isITI = selectedDepNames.some((depName) => depName.includes("iti"));

      if (isITI) {
        setSecureItem("DepartmentName", "ITI");
      } else {
        localStorage.removeItem("DepartmentName"); // Optional: clean up
      }
    }

    // Main data setting
    setLeaveRequestData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
        ...(name === "FromDate" && { ToDate: "" }), // Reset ToDate when FromDate is changed
      };

      // If FromDate or ToDate is changed, calculate NoOfDays
      if (name === "FromDate" || name === "ToDate") {
        if (updatedData.FromDate && updatedData.ToDate) {
          updatedData.NoOfDays = calculateDays(
            updatedData.FromDate,
            updatedData.ToDate
          );
        }
      }

      return updatedData;
    });
  };

  useEffect(() => {
    const fetGetLastWeekOff = async () => {
      try {
        const leavegetData = {
          UserId: UID,
          EmpId: leaveRequestData.EmpId,
        };
        const response = await GetLastWeekOff(leavegetData);
        console.log(response.data.data[0], "response");

        setLastWeekOff(response.data.data[0]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetGetLastWeekOff();
  }, [leaveRequestData.EmpId]);

  const fetchServiceReq = async () => {
    try {
      const res = await getServiceRequest(UID);
      // ✅ Filter Permission data
      const serviceData =
        res?.data?.data?.[0]?.filter((el) => el.TypeName === "Permission") ||
        [];

      // ✅ Filter by department if not admin
      const filteredData =
        isAdmina == 1
          ? serviceData
          : serviceData.filter((el) => el.DepartmentId === userDepartmentId);

      // ✅ Normalize service data to match leave data format
      const normalizedPermissionData = filteredData.map((el) => ({
        Id: el.RequestId,
        EmpId: el.EmpId,
        FromDate: el.Date,
        ToDate: el.Date, // For permission, FromDate and ToDate can be same
        DepartmentName: el.DepartmentName,
        ProfitcenterName: el.ProfitCenterName,
        NoOfDays: "N/A", // Permissions usually don't have NoOfDays
        Reason: el.EmpRemark,
        UserRemarks: el.UserRemarks,
        CurrentLevel: null,
        LeaveType: el.Type, // Map Type as LeaveType (or use a static ID if needed)
        Medical: null,
        LeaveRequestNumber: "", // Not applicable for permission
        SysTime: el.Systime,
        Name: el.EmployeeName,
        IsDirect: null,
        LeaveTypeName: "Permission",
        Status: parseInt(el.ServiceStatus),
        DepartmentID: el.DepartmentId,
        NameWithCode: `${el.EmployeeName} - ${el.EmpCode}`,
        TotalLevels: null,
        TotalLevelCount: 0,
      }));

      // ✅ Store as permission state if needed
      setPermissionsData(normalizedPermissionData);

      return normalizedPermissionData;
    } catch (error) {
      console.error("Error fetching service request", error);
      return []; // Safe fallback
    }
  };

  const handleChangeSelectLeave = (selectedOption) => {
    const { value, label } = selectedOption;

    setLeaveRequestData((prev) => {
      const updatedData = {
        ...prev,
        LeaveTypeId: value,
        NoOfDays:
          label === "Weekly Off"
            ? 1
            : label === "Morning HalfDay" || label === "Evening HalfDay"
            ? 0.5
            : prev.NoOfDays,
      };
      return updatedData;
    });
  };

  const handleChangeSelect = (e) => {
    const { value, label } = e;
    setLeaveRequestData((prev) => ({
      ...prev, // Spread the previous state to retain other properties
      EmpId: value,
      EmpName: label, // Update the `EmpId` field
    }));
  };
  const handleSubmit = async (e, pendingLeave) => {
    e.preventDefault();
    setLoading(true);
    try {
      const selectedLeaveType = pendingLeave?.find(
        (el) => el.TypeId === leaveRequestData.LeaveTypeId
      );
      const availableLeave = pendingleave?.find(
        (el) =>
          el.TypeId == leaveRequestData?.LeaveTypeId &&
          el.LeaveTypeName !== "Absent"
      );
      if (!leaveRequestData.LeaveTypeId) {
        toast.error("Invalid leave type");
        return;
      }
      if (leaveRequestData.NoOfDays > availableLeave?.Pending) {
        toast.error("Insufficient leave balance");
        return;
      }
      const fromDate = new Date(leaveRequestData.FromDate);

      const toDate =
        selectedLeaveTypeName === "Weekly Off" ||
        selectedLeaveTypeName === "Morning HalfDay" ||
        selectedLeaveTypeName === "Evening HalfDay"
          ? new Date(leaveRequestData.FromDate)
          : new Date(leaveRequestData.ToDate);
      const hasOverlappingLeave = allEmpLeaveReq.some((leave) => {
        if (
          leave.EmpId === leaveRequestData.EmpId &&
          (leave.Status === 0 || leave.Status === 1)
        ) {
          const existingFromDate = new Date(leave.FromDate);
          const existingToDate = new Date(leave.ToDate);
          const isOverlap =
            (fromDate >= existingFromDate && fromDate <= existingToDate) ||
            (toDate >= existingFromDate && toDate <= existingToDate) ||
            (fromDate <= existingFromDate && toDate >= existingToDate);
          return isOverlap;
        }
        return false;
      });
      if (hasOverlappingLeave) {
        toast.error(
          "Leave already requested or under process for the selected date range"
        );
        return;
      }
      const payload = {
        ...leaveRequestData,
        UserId: UID,
        RequestDate: new Date().toISOString().split("T")[0],
        ToDate:
          selectedLeaveTypeName === "Weekly Off" ||
          selectedLeaveTypeName === "Morning HalfDay" ||
          selectedLeaveTypeName === "Evening HalfDay"
            ? leaveRequestData.FromDate
            : leaveRequestData.ToDate,
      };
      // Use insertEmpLeaveRequestadminWeekly Off for specific leave types
      const response =
        selectedLeaveTypeName === "Weekly Off" ||
        selectedLeaveTypeName === "Morning HalfDay" ||
        selectedLeaveTypeName === "Evening HalfDay"
          ? await insertEmpLeaveRequestadminWeeklyOff(payload)
          : await InsertEmpLeavreqByUser(payload);

      if (response.data) {
        const updatedRequests = [
          ...leaveRequests,
          { ...payload, Id: response.data.id },
        ];
        setLeaveRequests(updatedRequests);
        setLeaveRequestData({});
        setAddLeaveRequestModal(false);
        toast.success("Leave Request Submitted Successfully");
        fetchAllEmpLeaveReq();
      } else {
        toast.error("Failed to submit leave request");
      }
    } catch (error) {
      console.error("Leave Request Error:", error);
      if (
        error.response?.data?.error === "Insufficient available leave days."
      ) {
        toast.error(
          "Insufficient leave balance. Please select 'Absent' to adjust your salary accordingly."
        );
      } else {
        toast.error(
          error.response?.data?.error || "Error submitting leave request"
        );
      }
    } finally {
      setLoading(false);
    }
  };
  // In your handleFileChange function, you might want to add:
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (e.g., max 5MB)
      const maxSizeInMB = 5;
      if (file.size / 1024 / 1024 > maxSizeInMB) {
        toast.error(`File size exceeds ${maxSizeInMB}MB limit`);
        e.target.value = ""; // Clear the file input
        return;
      }

      // Convert file to Base64
      const reader = new FileReader();
      reader.onload = (event) => {
        setLeaveRequestData((prev) => ({
          ...prev,
          Medical: event.target.result, // Store Base64 string
        }));
        toast.success("File selected successfully");
      };
      reader.onerror = () => {
        toast.error("Error reading file");
        e.target.value = ""; // Clear the file input
      };
      reader.readAsDataURL(file); // Convert file to Base64
    }
  };

  const handleEdit = async (e, pendingLeave) => {
    e.preventDefault();
    setLoading(true);

    try {
      const isSingleDayLeave =
        selectedLeaveTypeName === "Weekly Off" ||
        selectedLeaveTypeName === "Morning HalfDay" ||
        selectedLeaveTypeName === "Evening HalfDay";

      const fromDate = new Date(leaveRequestData.FromDate);
      const toDate = isSingleDayLeave
        ? new Date(leaveRequestData.FromDate)
        : new Date(leaveRequestData.ToDate);

      const hasOverlappingLeave = allEmpLeaveReq.some((leave) => {
        if (
          leave.EmpId === leaveRequestData.EmpId &&
          (leave.Status === 0 || leave.Status === 1)
        ) {
          const existingFromDate = new Date(leave.FromDate);
          const existingToDate = new Date(leave.ToDate);

          return (
            (fromDate >= existingFromDate && fromDate <= existingToDate) ||
            (toDate >= existingFromDate && toDate <= existingToDate) ||
            (fromDate <= existingFromDate && toDate >= existingToDate)
          );
        }
        return false;
      });

      if (hasOverlappingLeave) {
        toast.error(
          "Leave already requested or under process for the selected date range"
        );
        return;
      }

      const payload = {
        ...leaveRequestData,
        UserId: UID,
        RequestDate: new Date().toISOString().split("T")[0],
        ToDate: isSingleDayLeave
          ? leaveRequestData.FromDate
          : leaveRequestData.ToDate,
      };

      const response = isSingleDayLeave
        ? await insertEmpLeaveRequestadminWeeklyOff(payload)
        : await InsertEmpLeavreqByUser(payload);

      if (response.data) {
        const updatedRequests = [
          ...leaveRequests,
          { ...payload, Id: response.data.id },
        ];
        setLeaveRequests(updatedRequests);
        setLeaveRequestData({});
        seteditLeaveModal(false);
        toast.success("Leave Request updated Successfully");
        fetchAllEmpLeaveReq();
      } else {
        toast.error("Failed to Update leave request");
      }
    } catch (error) {
      console.error("Leave Request Error:", error);
      toast.error(
        error.response?.data?.message || "Error updating leave request"
      );
    } finally {
      setLoading(false);
    }
  };

 const handleStatusChange = async (e, status, selectedRequest) => {
  console.log(selectedRequest, 'dasdads');

  e.preventDefault();
  setLoading(true);

  const details = {
    Remarks: remarks,
    UserId: UID,
    Status: status,
    Id: selectedRequest?.Id,
    NoOfDays: NoofDays || selectedRequest?.NoOfDays,
  };

  try {
    if (selectedRequest?.DutyStatus === 1) {
      // Format dates for display
      const fromDate = selectedRequest?.FromDate 
        ? new Date(selectedRequest.FromDate).toLocaleDateString('en-GB') 
        : 'N/A';
      const toDate = selectedRequest?.ToDate 
        ? new Date(selectedRequest.ToDate).toLocaleDateString('en-GB') 
        : 'N/A';

      const proceed = window.confirm(
        `Between ${fromDate} and ${toDate}, duty is already allocated. Are you sure you want to proceed?`
      );

      if (!proceed) {
        setLoading(false);
        return;
      }
    }

    const response = await leaverequeststatuschange(details);

    if (response?.data) {
      let statusMessage = "";

      if (status === 1) statusMessage = "approved";
      else if (status === 2) statusMessage = "rejected";
      else statusMessage = "forwarded to next level";

      toast.success(`Request ${statusMessage} successfully`);
      setRejectModal(false);
      setApproveModal(false);
      fetchAllEmpLeaveReq();
    }
  } catch (error) {
    console.error("Leave Request Error:", error);
    toast.error(
      error.response?.data?.message || "Error submitting leave request"
    );
  } finally {
    setLoading(false);
  }
};

  const fetchAllEmpLeaveReq = async (employee) => {
    try {
      setLoading(true); // Start loading spinner

      // Prepare the data payload for the API request
      const data = {
        fromDate: fromDate || new Date().toISOString().split("T")[0], // Default to today's date
        toDate: toDate || new Date().toISOString().split("T")[0], // Default to today's date
        UserId: UID, // Logged-in user ID
      };

      const response = await GetLeavsAllemployesss(data);

      if (response && response.data && response.data.data) {
        let filteredData = response.data.data;
        const details =
          isAdmina == 1
            ? response?.data?.data
            : response?.data?.data?.filter(
                (el) => el?.DepartmentID == userDepartmentId
              );
        setAllEmpLeaveReq(details);
      } else {
        console.error(
          "Invalid response structure. Ensure the API returns expected data."
        );
      }
    } catch (error) {
      console.error("Error fetching employee leave data:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredItems = dataFilter?.filter((item) => {
    const searchText = filterText.toLowerCase();

    const itemFromDate = new Date(item?.FromDate);
    const itemToDate = new Date(item?.ToDate);
    const startDate = fromDate ? new Date(fromDate) : null;
    const endDate = toDate ? new Date(toDate) : null;

    const isWithinDateRange =
      !startDate ||
      !endDate ||
      (itemFromDate <= endDate && itemToDate >= startDate);

    // Safely compute the status text based on status value
    const statusText =
      item?.Status === 2
        ? "rejected"
        : item?.Status === 1
        ? "approved"
        : item?.Status === 0
        ? "approval pending"
        : "";

    return (
      isWithinDateRange &&
      (item?.NameWithCode?.toLowerCase().includes(searchText) ||
        item?.LeaveTypeName?.toLowerCase().includes(searchText) ||
        statusText.toLowerCase().includes(searchText) ||
        department.some(
          (el) =>
            el.Name.toLowerCase().includes(searchText) &&
            el.Id === item?.DepartmentID
        ))
    );
  });

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const getleaves = async () => {
    const data = {
      Date: date || new Date().toISOString().split("T")[0], // Use the current date if `date` is falsy
      UserId: UID,
    };
    try {
      const response = await GetNoOfLeaveWithDate(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchEmployeeWithLeave = async () => {
    const data = {
      Date: date || new Date().toISOString().split("T")[0], // Use the current date if `date` is falsy
      UserId: UID,
    };
    try {
      // setLoading(true);
      const response = await getEmpLeaveRequest(data);
      // setduties(response.data.data);
      setDataFilter(response.data.data);
    } catch (error) {
      console.error("Error fetching duty data", error);
    } finally {
      // setLoading(false);
    }
  };

  const order = [
    "Casual",
    "Annual",
    "Morning",
    "Evening",
    "Weekly",
    "Sick",
    "Absent",
  ];

  const isITI = departmentName?.toLowerCase().includes("iti");

  const leaveTypeName = pendingleave
    .filter((el) => {
      // If department is ITI, exclude leaves with "week" in name
      return isITI ? !el.LeaveTypeName?.toLowerCase().includes("week") : true;
    })
    .sort((a, b) => {
      const aIndex = order.findIndex((ord) =>
        a.LeaveTypeName?.toLowerCase().includes(ord.toLowerCase())
      );
      const bIndex = order.findIndex((ord) =>
        b.LeaveTypeName?.toLowerCase().includes(ord.toLowerCase())
      );

      // If not found in order list, push them to the end.
      return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
    })
    .map((el) => ({
      value: el.TypeId,
      label: el.LeaveTypeName,
    }));

  const openEditLeveRequestModal = (data) => {
    seteditLeaveModal(true);
    setLeaveRequestData({
      Id: data.Id,
      EmpId: data.EmpId,
      EmpName: data.Name,
      LeaveTypeId: data.LeaveType,
      FromDate: data.FromDate.split("T")[0],
      ToDate: data.ToDate.split("T")[0],
      NoOfDays: data.NoOfDays,
      UserRemarks: data.UserRemarks,
      DepartmentId: data.DepartmentID,
      Medical: data.Medical,
      // Reset other fields if needed
      Status: data.Status || 0,
      // Add any other necessary fields
    });
  };

  const clearLeaveRequestData = () => {
    setLeaveRequestData({
      Id: "",
      EmpId: "",
      EmpName: "",
      LeaveTypeId: "",
      FromDate: "",
      ToDate: "",
      NoOfDays: "",
      Reason: "",
      Status: 0,
      DepartmentId: "",
    });
  };

  const clearDataForEdit = () => {
    setLeaveRequestData((ref) => ({
      ...ref, // Spread the previous state
      EmpId: "",
      EmpName: "",
      LeaveTypeId: "",
      FromDate: "",
      ToDate: "",
      NoOfDays: "",
      Reason: "",
      Status: 0,
      DepartmentId: "", // Assuming UID is a variable or state you have defined
    }));
  };

  const columnsFilter = [
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },

    {
      name: "Emp_Name",
      selector: (row) => row.NameWithCode,
      sortable: true,
      width: "200px",
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },

    {
      name: "Emp_Dep",
      selector: (row) => {
        const matchedDepartment = department.find(
          (el) => el.Id === row.DepartmentID
        );
        return matchedDepartment ? matchedDepartment.Name : "";
      },
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "Leave Type",
      selector: (row) => row.LeaveTypeName,
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "Reason",
      selector: (row) => row.Reason,
      sortable: true,
      width: "500px",

      cell: (row) => {
        const ReasonCell = () => {
          const [expanded, setExpanded] = React.useState(false);
          const text = row.Reason || "";

          const wrapText = (str, width = 70) =>
            str.match(new RegExp(`.{1,${width}}`, "g")).join("\n");

          const isLong = text.length > 70;
          const displayText = expanded ? wrapText(text) : text.slice(0, 70);

          return (
            <div style={{ whiteSpace: "pre-line" }}>
              {displayText}
              {isLong && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpanded(!expanded);
                  }}
                  style={{ color: "blue", cursor: "pointer", marginLeft: 5 }}
                >
                  {expanded ? " Read Less" : " ...Read More"}
                </span>
              )}
            </div>
          );
        };

        return <ReasonCell />;
      },
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },

    {
      name: "Medical Certificate",
      selector: (row) => row.Medical, // Used for internal logic
      cell: (row) => (
        <>
          <button
            disabled={
              row.LeaveTypeName !== "Sick" ||
              row.Medical == null ||
              row.Medical == ""
            }
            className="btn btn-primary"
            onClick={() => window.open(`${IMAGE_URL}/${row.Medical}`, "_blank")}
            style={{ padding: "5px 10px", cursor: "pointer" }}
          >
            View
          </button>
        </>
      ),
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },

    {
      name: "No of Days",
      selector: (row) => row.NoOfDays,
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "From Date",
      selector: (row) => new Date(row.FromDate).toLocaleDateString("en-GB"),
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "To Date",
      selector: (row) => new Date(row.ToDate).toLocaleDateString("en-GB"),
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "Reason",
      selector: (row) => row?.UserRemarks || "_",
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
    },
    {
      name: "Status",
      selector: (row) => {
        switch (row.Status) {
          case 1:
            return "Approved";
          case 2:
            return "Rejected";
          case 11:
            return "Cancelled";
          default:
            return "Approval Pending";
        }
      },
      conditionalCellStyles: [
        {
          when: (row) => row.Status === 1,
          style: {
            backgroundColor: "#e6f3e6",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 2,
          style: {
            backgroundColor: "#ffd1dc",
            color: "#000",
          },
        },
        {
          when: (row) => row.Status === 11,
          style: {
            backgroundColor: "#fffacd",
            color: "#000",
          },
        },
      ],
      sortable: true,
    },
    {
      name: "Action",
      grow: 0,
      width: "350px",
      cell: (row) => {
        const isPermission = row.LeaveTypeName === "Permission";

        // Rejected or Cancelled — No actions
        if (row.Status === 11 || row.Status === 2) {
          return null;
        }

        // Permission type but not pending — No actions
        if (isPermission && row.Status !== 0) {
          return null;
        }

        const totalLevels =
          typeof row.TotalLevels === "string"
            ? JSON.parse(row.TotalLevels)
            : row.TotalLevels || [];

        const totalLevelCount = row.TotalLevelCount || totalLevels.length;
        const currentLevel = row.CurrentLevel || 0;
        const isFinalApproval = currentLevel === totalLevelCount;

        // Approved Leave (non-permission): Show Cancel Leave
        if (row.Status === 1 && !isPermission) {
          return (
            <div className="flex items-center gap-4">
              <button
                disabled={UserType?.toLowerCase() === "departmenthead"}
                className="btn btn-danger"
                onClick={() => handlerecall(row)}
              >
                Cancel Leave
              </button>
            </div>
          );
        }

        // Pending Permission — Show Permission Approve/Reject
        if (isPermission && row.Status === 0) {
          return (
            <div className="flex items-center gap-4">
              <button
                className="btn btn-success"
                onClick={() => handleChnagePermissionStatus(row, "approve")}
              >
                Permission Approve
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleChnagePermissionStatus(row, "reject")}
              >
                Permission Reject
              </button>
            </div>
          );
        }

        // Non-permission leave actions
        return (
          <div className="flex items-center gap-4">
            {/* Edit for pending (non-permission) */}
            {row.Status === 0 && (
              <button
                className="bg-sky rounded-[4px] px-10 py-[8px]"
                onClick={() => openEditLeveRequestModal(row)}
              >
                <IconEdit className="text-white w-[18px] h-[18px]" />
              </button>
            )}

            {/* Case 1: Direct Approval Flow */}
            {row.IsDirect === true && (
              <>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    setSelectedRequest(row);
                    setNoofDays(row.NoOfDays);
                    setApproveModal(true);
                  }}
                >
                  Approve
                </button>

                {!isFinalApproval && (
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      setSelectedRequest(row);
                      setNoofDays(row.NoOfDays);
                      handleStatusChange(
                        e,
                        row.Status === 0 ? 3 : row.Status + 1,
                        row
                      );
                    }}
                  >
                    Forward NextLevel
                  </button>
                )}
              </>
            )}

            {/* Case 2: Multi-Level Flow */}
            {row.IsDirect === false && (
              <>
                {isFinalApproval || totalLevelCount === 1 ? (
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      setSelectedRequest(row);
                      setNoofDays(row.NoOfDays);
                      setApproveModal(true);
                    }}
                  >
                    Approve
                  </button>
                ) : (
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      setSelectedRequest(row);
                      setNoofDays(row.NoOfDays);
                      handleStatusChange(
                        e,
                        row.Status === 0 ? 3 : row.Status + 1,
                        row
                      );
                    }}
                  >
                    Forward Next Level
                  </button>
                )}
              </>
            )}

            {/* Case 3: Fallback Approval */}
            {row.IsDirect === null && (
              <button
                className="btn btn-success"
                onClick={() => {
                  setSelectedRequest(row);
                  setNoofDays(row.NoOfDays);
                  setApproveModal(true);
                }}
              >
                Approve
              </button>
            )}

            {/* Reject Button */}
            <button
              className="btn btn-danger"
              onClick={() => {
                setSelectedRequest(row);
                setRejectModal(true);
              }}
            >
              Reject
            </button>
          </div>
        );
      },
    },

    {
      name: "View History",
      sortable: true,
      width: "250px",

      cell: (row) => (
        <Link
          to="/LeaveTranceActionHistory"
          state={{ empId: row.EmpId }} // ✅ Correct way to pass state
          className="bg-blue text-white px-3 py-1 rounded"
        >
          Click Here
        </Link>
      ),
    },
  ];

  const getMaxDate = (days) => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + days);
    return maxDate.toISOString().split("T")[0];
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };

  const selectedLeaveTypeName = otherLeaves.find(
    (type) => type.Id === leaveRequestData.LeaveTypeId
  )?.Name;

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  const ExportToPdf = (fromDate, toDate) => {
    function formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }

    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);

    if (filteredItems && filteredItems.length) {
      // Group data by department
      const groupedByDepartment = filteredItems?.reduce((acc, item) => {
        if (!acc[item.DepartmentName]) acc[item.DepartmentName] = [];
        acc[item.DepartmentName].push(item);
        return acc;
      }, {});

      // Initialize jsPDF instance with landscape orientation for better table width
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // Define margins
      const leftMargin = 15; // Reduced margin for more space
      const rightMargin = 15; // Reduced margin for more space
      const pageWidth = doc.internal.pageSize.width;
      const contentWidth = pageWidth - leftMargin - rightMargin;

      // Add document title with styling
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(`${companyDetails.Name.toUpperCase()}`, pageWidth / 2, 15, {
        align: "center",
      });

      doc.setFontSize(10);
      doc.text(
        `LEAVE REPORT  ${formattedFromDate} to ${formattedToDate}`,
        pageWidth / 2,
        23,
        { align: "center" }
      );

      // Add date
      const today = new Date();
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(
        `Generated on: ${today.toLocaleDateString("en-GB")}`,
        pageWidth - rightMargin,
        10,
        { align: "right" }
      );

      let yOffset = 30; // Starting vertical offset

      // Iterate through departments and add data
      for (const [department, data] of Object.entries(groupedByDepartment)) {
        // Add department heading with styling
        doc.setFontSize(7);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(`Department: ${department}`, leftMargin, yOffset);
        yOffset += 8;

        // Prepare table headers and rows
        const headers = [
          [
            "Name & Code",
            "From Date",
            "To Date",
            "Days",
            "Leave Type",
            "Reason",
            "Status",
          ],
        ];

        const getStatusText = (status) => {
          switch (status) {
            case 1:
              return "Approved";
            case 2:
              return "Rejected";
            case 11:
              return "Cancelled";
            default:
              return "Pending";
          }
        };

        const rows = data.map((item) => [
          item.NameWithCode,
          formatDate(item.FromDate),
          formatDate(item.ToDate),
          item.NoOfDays,
          item.LeaveTypeName,
          item.Reason || "N/A",
          getStatusText(item.Status),
        ]);

        // Calculate column widths based on available content width
        // Total should equal 100% (1.0)
        const nameWidth = contentWidth * 0.22; // 22% for Name
        const fromDateWidth = contentWidth * 0.12; // 12% for From Date
        const toDateWidth = contentWidth * 0.12; // 12% for To Date
        const daysWidth = contentWidth * 0.08; // 8% for No. of Days
        const leaveTypeWidth = contentWidth * 0.15; // 15% for Leave Type
        const reasonWidth = contentWidth * 0.19; // 19% for Reason
        const statusWidth = contentWidth * 0.12; // 12% for Status
        // Total = 100%

        // Add table to PDF with improved styling and proper margins
        doc.autoTable({
          startY: yOffset,
          head: headers,
          body: rows,
          theme: "grid", // Use grid theme for visible borders
          styles: {
            fontSize: 8, // Reduced font size for better fit
            cellPadding: 2, // Reduced padding
            lineWidth: 0.3, // Thinner border
            lineColor: [0, 0, 0], // Black border
            overflow: "linebreak", // Allow text wrapping
          },
          headStyles: {
            fillColor: [240, 240, 240], // Light gray header
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
            lineWidth: 0.5,
            minCellHeight: 8,
          },
          bodyStyles: {
            fillColor: [255, 255, 255], // White background
            textColor: [0, 0, 0],
            lineWidth: 0.3,
            valign: "middle",
          },
          alternateRowStyles: {
            fillColor: [252, 252, 252], // Very light gray for alternate rows
          },
          columnStyles: {
            0: { cellWidth: nameWidth, halign: "left" }, // Name column
            1: { cellWidth: fromDateWidth, halign: "center" }, // From Date
            2: { cellWidth: toDateWidth, halign: "center" }, // To Date
            3: { cellWidth: daysWidth, halign: "center" }, // No. of Days
            4: { cellWidth: leaveTypeWidth, halign: "center" }, // Leave Type
            5: { cellWidth: reasonWidth, halign: "left" }, // Reason
            6: { cellWidth: statusWidth, halign: "center" }, // Status
          },
          margin: {
            left: leftMargin,
            right: rightMargin,
            top: 10,
            bottom: 10,
          },
          tableWidth: contentWidth,
          didDrawPage: (data) => {
            // Add page number at bottom with proper margin
            doc.setFontSize(8);
            doc.text(
              `Page ${doc.internal.getNumberOfPages()}`,
              pageWidth - rightMargin,
              doc.internal.pageSize.height - 10,
              { align: "right" }
            );
          },
        });

        // Update yOffset for next department
        yOffset = doc.lastAutoTable.finalY + 15;

        // Add page break if near bottom and more departments to come
        const remainingDepartments =
          Object.entries(groupedByDepartment).length -
          (Object.entries(groupedByDepartment).findIndex(
            ([dept]) => dept === department
          ) +
            1);

        if (
          yOffset > doc.internal.pageSize.height - 40 &&
          remainingDepartments > 0
        ) {
          doc.addPage();
          yOffset = 30; // Reset with top margin
        }
      }

      // Add summary at the end with proper positioning
      if (doc.lastAutoTable.finalY + 20 < doc.internal.pageSize.height - 30) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "italic");
        doc.text(
          "End of Report",
          pageWidth / 2,
          doc.lastAutoTable.finalY + 15,
          { align: "center" }
        );
      } else {
        doc.addPage();
        doc.setFontSize(10);
        doc.setFont("helvetica", "italic");
        doc.text("End of Report", pageWidth / 2, 50, { align: "center" });
      }

      // Save the PDF with formatted name
      const fileName = `${companyDetails.Name}_LeaveRequests_${formattedFromDate}_to_${formattedToDate}.pdf`;
      doc.save(fileName);
    } else {
      console.log("No data available to export");
    }
  };

  const ExportToPdfconsoldate = (
    fromDate,
    toDate,
    leaveData = filteredItems
  ) => {
    // Input validation
    if (!fromDate || !toDate) {
      console.error("From date and to date are required");
      return;
    }

    if (!leaveData || !Array.isArray(leaveData)) {
      console.error("No valid leave data provided");
      return;
    }

    // Filter for status 1 items only (approved leaves)
    const filterWithLeaveStatus = leaveData.filter((el) => {
      return el && el.Status == 1; // Only include items with Status = 1
    });

    // Helper function to format dates
    function formatDate(dateStr) {
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date");
        }
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      } catch (error) {
        console.error("Error formatting date:", error);
        return "Invalid Date";
      }
    }

    // Helper function to calculate overlapping days between two date ranges
    function calculateOverlappingDays(
      leaveFromDate,
      leaveToDate,
      filterFromDate,
      filterToDate
    ) {
      const leaveStart = new Date(leaveFromDate);
      const leaveEnd = new Date(leaveToDate);
      const filterStart = new Date(filterFromDate);
      const filterEnd = new Date(filterToDate);

      // Find the overlap period
      const overlapStart = new Date(
        Math.max(leaveStart.getTime(), filterStart.getTime())
      );
      const overlapEnd = new Date(
        Math.min(leaveEnd.getTime(), filterEnd.getTime())
      );

      // If there's no overlap, return 0
      if (overlapStart > overlapEnd) {
        return 0;
      }

      // Calculate the number of days in the overlap (inclusive)
      const timeDiff = overlapEnd.getTime() - overlapStart.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; // +1 to make it inclusive

      return daysDiff;
    }

    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);

    if (!filterWithLeaveStatus || filterWithLeaveStatus.length === 0) {
      return;
    }

    // More flexible leave type definitions
    const leaveTypes = [
      "Casual",
      "Sick",
      "Annual leave",
      "Absent",
      "Maternity Leave",
      "Special Leave",
    ];
    const groupedByLeaveType = {};

    filterWithLeaveStatus.forEach((item) => {
      // More robust leave type checking
      if (item && item.LeaveTypeName) {
        const leaveTypeName = item.LeaveTypeName.trim();

        // Case-insensitive matching
        const matchedLeaveType = leaveTypes.find(
          (type) => type.toLowerCase() === leaveTypeName.toLowerCase()
        );

        if (matchedLeaveType) {
          if (!groupedByLeaveType[matchedLeaveType]) {
            groupedByLeaveType[matchedLeaveType] = [];
          }
          groupedByLeaveType[matchedLeaveType].push(item);
        } else {
          console.warn(`Unknown leave type: ${leaveTypeName}`);
        }
      }
    });

    // Check if we have any valid leave types to process
    if (Object.keys(groupedByLeaveType).length === 0) {
      return;
    }

    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      let isFirstPage = true;

      Object.entries(groupedByLeaveType).forEach(
        ([leaveTypeName, leaveData]) => {
          if (!isFirstPage) {
            doc.addPage();
          }
          isFirstPage = false;

          let yOffset = 15;

          // Add company name with better error handling
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.setTextColor(0, 0, 0);
          const companyName = (
            companyDetails?.Name || "Company Name"
          ).toUpperCase();
          doc.text(companyName, doc.internal.pageSize.width / 2, yOffset, {
            align: "center",
          });
          yOffset += 7;

          // Add leave type heading
          doc.setFontSize(12);
          const displayLeaveType =
            leaveTypeName === "Absent" ? "LOP" : leaveTypeName;
          doc.text(
            `${displayLeaveType} Leave Details`,
            doc.internal.pageSize.width / 2,
            yOffset,
            { align: "center" }
          );
          yOffset += 6;

          // Add date range
          doc.setFontSize(10);
          doc.text(
            `${formattedFromDate} to ${formattedToDate}`,
            doc.internal.pageSize.width / 2,
            yOffset,
            { align: "center" }
          );
          yOffset += 8;

          // Process employee data with CORRECTED date range calculation
          const employeeData = {};
          leaveData.forEach((item) => {
            if (
              item &&
              item.NameWithCode &&
              item.Name &&
              item.FromDate &&
              item.ToDate
            ) {
              const empKey = item.NameWithCode;
              if (!employeeData[empKey]) {
                // Better parsing of employee code
                const codeParts = item.NameWithCode.split(" - ");
                employeeData[empKey] = {
                  name: item.Name,
                  code: codeParts.length > 1 ? codeParts[1] : codeParts[0],
                  totalDays: 0,
                };
              }

              // **FIXED: Calculate only the overlapping days within the selected date range**
              const overlappingDays = calculateOverlappingDays(
                item.FromDate,
                item.ToDate,
                fromDate,
                toDate
              );

              employeeData[empKey].totalDays += overlappingDays;
            }
          });

          // Filter out employees with 0 days in the selected range
          const employeeArray = Object.values(employeeData)
            .filter((emp) => emp.totalDays > 0)
            .sort((a, b) =>
              a.code.localeCompare(b.code, undefined, { numeric: true })
            );

          const headers = [
            ["Sl.No.", "Employee Code", "Employee Name", displayLeaveType],
          ];

          const rows = [];
          let slNo = 1;
          let totalLeaveTypedays = 0;

          employeeArray.forEach((emp) => {
            rows.push([slNo++, emp.code, emp.name, emp.totalDays.toFixed(1)]);
            totalLeaveTypedays += emp.totalDays;
          });

          // Only add total row if there are employees with leaves in the selected range
          if (employeeArray.length > 0) {
            rows.push([
              "",
              "",
              `Total ${displayLeaveType}`,
              totalLeaveTypedays.toFixed(1),
            ]);
          }

          // Only draw table if there are rows to show
          if (rows.length > 0) {
            // Draw table with autoTable
            doc.autoTable({
              startY: yOffset,
              head: headers,
              body: rows,
              theme: "grid",
              styles: {
                fontSize: 9,
                cellPadding: 2,
                lineWidth: 0.3,
                lineColor: [0, 0, 0],
                minCellHeight: 6,
                font: "helvetica",
              },
              headStyles: {
                fillColor: [240, 240, 240],
                textColor: [0, 0, 0],
                fontStyle: "bold",
                halign: "center",
                lineWidth: 0.3,
              },
              bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                lineWidth: 0.3,
                halign: "center",
              },
              columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 30 },
                2: { cellWidth: 80, halign: "left" },
                3: { cellWidth: 30 },
              },
              margin: { left: 25, right: 15 },
              pageBreak: "auto",
              didDrawCell: (data) => {
                if (data.row.index === rows.length - 1) {
                  data.cell.styles.fillColor = [230, 230, 230];
                  data.cell.styles.fontStyle = "bold";
                }
              },
              didDrawPage: (data) => {
                const pageWidth = doc.internal.pageSize.width || 210;
                const pageHeight = doc.internal.pageSize.height || 297;
                doc.setFontSize(8);
                doc.setFont("helvetica", "normal");
                doc.text(
                  `Page ${doc.internal.getNumberOfPages()}`,
                  pageWidth - 15,
                  pageHeight - 10,
                  { align: "right" }
                );
              },
            });

            // Signature fields after table
            let signatureYOffset = doc.previousAutoTable.finalY + 10;
            const pageWidth = doc.internal.pageSize.width || 210;
            const leftMargin = 25;
            const rightMargin = 15;
            const availableWidth = pageWidth - leftMargin - rightMargin;
            const columnSpacing = availableWidth / 4;

            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.text("CLERK", leftMargin + columnSpacing * 0, signatureYOffset);
            doc.text(
              "ACCOUNTS OFFICER",
              leftMargin + columnSpacing * 1,
              signatureYOffset
            );
            doc.text(
              "SECRETARY",
              leftMargin + columnSpacing * 2,
              signatureYOffset
            );
            doc.text(
              "PRESIDENT",
              leftMargin + columnSpacing * 3,
              signatureYOffset
            );
          } else {
            // If no data for this leave type in the selected range, add a note
            doc.setFontSize(10);
            doc.text(
              `No ${displayLeaveType} leaves found in the selected date range.`,
              doc.internal.pageSize.width / 2,
              yOffset + 20,
              { align: "center" }
            );
          }
        }
      );

      // Generate filename with better sanitization
      const sanitizedCompanyName = (companyDetails?.Name || "Company").replace(
        /[^a-zA-Z0-9]/g,
        "_"
      );
      const fileName = `${sanitizedCompanyName}_LeaveDetails_${formattedFromDate}_to_${formattedToDate}.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleShowColorCode = () => {
    setmoadaopen(true);
  };

  const Modalback = () => {
    setmoadaopen(false);
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    const currentDate = getTodayDate();
    getleaves();
    // GetNoOfLeaveWithDate()
    fetchEmployeeWithLeave();
  }, []);

  useEffect(() => {
    const fetchemployee = async () => {
      try {
        const response = await getEmployee(UID);
        setEmployee(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchemployee();
  }, []);

  useEffect(() => {
    const fetchOtherLeaves = async () => {
      try {
        const response = await GetOtherLeaves(UID);
        setOtherLeaves(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchOtherLeaves();
  }, []);

  useEffect(() => {
    const fetchEmpLeaveData = async () => {
      const UserId = UID;
      try {
        const response = await ProcessEmpLeaveALL(UserId);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchEmpLeaveData();
  }, []);

  useEffect(() => {
    const fetchpendingLeave = async () => {
      const leavegetData = {
        UserId: UID,
        EmpId: leaveRequestData.EmpId,
      };

      try {
        const response = await GetPendingLeave(leavegetData);

        // Hardcoded additional leave types
        const hardcodedLeaveTypes = otherLeaves.map((el) => ({
          TypeId: el.Id,
          LeaveTypeName: el.Name,
          Pending: 10,
          NoOfLeaves: 10,
        }));

        // Merge hardcoded leave types with API response, avoiding duplicates
        let mergedLeaveTypes = [
          ...hardcodedLeaveTypes,
          ...response.data.data.filter(
            (apiLeave) =>
              !hardcodedLeaveTypes.some(
                (hardcoded) => hardcoded.TypeId === apiLeave.TypeId
              )
          ),
        ];

        // Check if Casual or Annual leave exists
        const hasCasualOrAnnual = mergedLeaveTypes.some(
          (leave) =>
            leave.LeaveTypeName?.toLowerCase() === "casual" ||
            leave.LeaveTypeName?.toLowerCase() === "annual leave"
        );

        if (!hasCasualOrAnnual) {
          // Exclude Morning HalfDay and Evening HalfDay
          mergedLeaveTypes = mergedLeaveTypes.filter(
            (leave) =>
              leave.LeaveTypeName !== "Morning HalfDay" &&
              leave.LeaveTypeName !== "Evening HalfDay"
          );
        }

        console.log(mergedLeaveTypes, "mergedLeaveTypes");

        setPendingleave(mergedLeaveTypes);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching GetPendingLeave centers:", error);
      }
    };

    fetchpendingLeave();
  }, [leaveRequestData.EmpId]);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchDepartment();
  }, []);

  useEffect(() => {
    const currentDate = getTodayDate();
    setDate(currentDate);
    setFromDate(currentDate);
    setToDate(currentDate);

    setLoading(true);
  }, []);

  useEffect(() => {}, [leaveRequestData]);

  useEffect(() => {
    fetchServiceReq();
    fetchAllEmpLeaveReq();
  }, [date]);

  useEffect(() => {
    const mergeData = () => {
      const combined = [...(permissionsData || []), ...(allEmpLeaveReq || [])];
      setfinaldata(combined);
    };

    mergeData();
  }, [permissionsData, allEmpLeaveReq]);

  useEffect(() => {
    setDataFilter(finalData);
  }, [finalData]);

  const getTwoDaysBackDate = () => {
    const d = new Date();
    d.setDate(d.getDate() - 2);
    return d.toISOString().split("T")[0];
  };
  const isAdminValue = Number(isAdmina);

  const isWeeklyOffDisabled =
    selectedLeaveTypeName === "Weekly Off" &&
    lastWeekOff?.IsWeekOffApplicable === false;

  const getWeeklyOffMinDate = () => {
    if (!lastWeekOff?.LastWeekOffApproveOn) {
      return getTodayDate();
    }

    // Disable NEXT 5 days → enable on 6th day
    const lastApprovalDate = new Date(lastWeekOff.LastWeekOffApproveOn);
    lastApprovalDate.setDate(lastApprovalDate.getDate() + 6);

    const enableDate = lastApprovalDate.toISOString().split("T")[0];
    const today = getTodayDate();

    // Never allow past dates
    return enableDate > today ? enableDate : today;
  };

  const formatDate = (dateStr) => dateStr?.split("T")[0];

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d.toISOString().split("T")[0];
  };

  return (
    <>
      {moadaopen && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="p-8 rounded-xl shadow-xl bg-white w-[700px] max-h-[550px] flex flex-col">
            <div className="flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Color Codes
              </h2>
            </div>
            <div className="flex-grow overflow-y-auto max-h-[450px] pr-4">
              <div className="space-y-4">
                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#e6f3e6] mr-4"></div>
                  <div>
                    <p className="font-medium">Approved</p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#ffd1dc] mr-4"></div>
                  <div>
                    <p className="font-medium">Rejected</p>
                    {/* <p className="text-sm text-gray-500">Employees who have not yet Punched </p> */}
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#fffacd] mr-4"></div>
                  <div>
                    <p className="font-medium">Employee Canceld</p>
                    {/* <p className="text-sm text-gray-500">Employees punched</p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                onClick={Modalback}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
        {/* Breadcrumb */}
        <div className="w-full sm:w-auto">
          <Breadcrumb title="Leave Request" />
        </div>

        {/* Main Controls */}
        <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto">
          {/* Search and Filter */}
          <div className="flex items-center gap-2 bg-gray-100 p-2 sm:p-5 rounded-md mt-4">
            <button
              className="bg-sky text-white rounded-[4px] px-4 py-2 flex items-center justify-center"
              onClick={handleFilterClick}
            >
              <IconFilter className="w-[18px] h-[18px]" />
            </button>

            <div className="relative w-full">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search here..."
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md"
              />
            </div>

            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={() => {
              setAddLeaveRequestModal(true);
              setPendingleave([]);
            }}
            className="btn btn-primary mt-4"
          >
            Add New
          </button>
        </div>
      </div>

      {/* Filter Component */}
      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={finalData}
          onFilter={handleFilter}
        />
      )}

      <div className="flex gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium">From Date:</label>
          <input
            type="date"
            className="border rounded px-2 py-1"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium">To Date:</label>
          <input
            type="date"
            className="border rounded px-2 py-1"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <button
          className="btn btn-success h-[40px] mt-4"
          onClick={fetchAllEmpLeaveReq}
        >
          Show
        </button>
        <button
          className="btn btn-success h-[40px] mt-4"
          onClick={() => ExportToPdf(fromDate, toDate)}
        >
          Download Detailed PDF
        </button>
        <button
          className="btn btn-danger h-[40px] mt-4"
          onClick={() => ExportToPdfconsoldate(fromDate, toDate)}
        >
          Download consolidated PDF
        </button>

        <button
          className="btn btn-primary h-[40px] mt-4"
          onClick={handleShowColorCode}
        >
          Show Color Info
        </button>
      </div>

      {/* Data Table */}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              // conditionalRowStyles={conditionalRowStyles}
            />
          )}
        </div>

        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h3 className="font-medium mb-2">Instructions:</h3>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
            <li>Select a date range to display leaves.</li>
            <li>
              Click "Forward to Next Level" to forward the request to the next
              level.
            </li>
          </ul>
        </div>
      </div>

      {/** add new leave request modal */}
      {addLeaveRequestModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Leave Request
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      // For Add modal close
                      onClick={() => {
                        clearLeaveRequestData();
                        setAddLeaveRequestModal(false);
                      }}
                      // For Edit modal close

                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>

                <div className="text-center ">
                  <span className="font-medium text-red-500 text-sm">
                    Pending Leaves
                  </span>
                  <hr className="   w-1/2 mx-auto" />
                </div>

                <div className="flex  gap-6 justify-center w-full">
                  {pendingleave
                    .filter((el) => {
                      const name = el.LeaveTypeName.trim().toLowerCase();
                      return ![
                        "absent",
                        "morning halfday",
                        "evening halfday",
                        "weekly off",
                        "week off",
                      ].includes(name);
                    })
                    .map((el, index) => (
                      <div
                        key={index}
                        className="p-3 rounded-lg shadow-sm flex flex-col items-center w-48 sm:w-72 md:w-80 lg:w-96 h-25 text-center"
                      >
                        <div className="font-semibold text-gray-800 ">
                          {el.LeaveTypeName}
                        </div>
                        <div className="mt-2">
                          <span className="text-gray-600 ">
                            {el.Pending}/{el.NoOfLeaves}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="my-10 md:px-10 px-[9px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    {isAdmina == 1 && (
                      <div className="form-group flex col-span-12 flex-col">
                        <label>
                          Select Department
                          <span style={{ color: "red" }}> *</span>
                        </label>
                        <select
                          name="DepartmentId"
                          value={leaveRequestData.DepartmentId || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select department</option>
                          {department.map((el) => (
                            <option key={el.Id} value={el.Id}>
                              {el.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={empOptionForLeave}
                        value={{
                          value: leaveRequestData.EmpId,
                          label: leaveRequestData.EmpName,
                        }}
                        onChange={(e) => {
                          handleChangeSelect(e);
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Leave Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        name="LeaveType"
                        value={leaveRequestData.LeaveType} // ensure this is the correct key in your state
                        onChange={handleChangeSelectLeave}
                        required
                        options={leaveTypeName}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group flex col-span-6 flex-col">
                      <label>
                        From Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        name="FromDate"
                        value={leaveRequestData.FromDate || ""}
                        onChange={handleChange}
                        required
                        disabled={isWeeklyOffDisabled}
                        className="form-control"
                        min={(() => {
                          const admin = Number(isAdmina); // 🔥 FIX

                          // ✅ Admin → ONLY Weekly-off logic
                          if (admin === 1) {
                            return selectedLeaveTypeName === "Weekly Off"
                              ? getWeeklyOffMinDate()
                              : "1900-01-01";
                          }

                          // ❌ Non-admin → backdate + weekly-off
                          const back2 = getTwoDaysBackDate();

                          const weeklyOffMin =
                            selectedLeaveTypeName === "Weekly Off"
                              ? getWeeklyOffMinDate()
                              : "1900-01-01";

                          return back2 > weeklyOffMin ? back2 : weeklyOffMin;
                        })()}
                      />

                      {isWeeklyOffDisabled && (
                        <span className="text-red-600 text-sm mt-1">
                          Approval Pending on{" "}
                          {lastWeekOff.PendingDate
                            ? formatDate(lastWeekOff.PendingDate)
                            : "previous approval"}
                        </span>
                      )}
                    </div>

                    {selectedLeaveTypeName !== "Weekly Off" &&
                      selectedLeaveTypeName !== "Morning HalfDay" &&
                      selectedLeaveTypeName !== "Evening HalfDay" && (
                        <div className="form-group flex col-span-6 flex-col">
                          <label>
                            To Date <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="date"
                            name="ToDate"
                            value={leaveRequestData.ToDate || ""}
                            onChange={handleChange}
                            required
                            min={leaveRequestData.FromDate}
                            className="form-control"
                          />
                        </div>
                      )}

                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Number of Days <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        name="NoOfDays"
                        value={leaveRequestData.NoOfDays || ""}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "e" ||
                            selectedLeaveTypeName === "Weekly Off" ||
                            selectedLeaveTypeName === "Morning HalfDay" ||
                            selectedLeaveTypeName === "Evening HalfDay"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        required
                        min="0"
                        readOnly={
                          selectedLeaveTypeName === "Weekly Off" ||
                          selectedLeaveTypeName === "Morning HalfDay" ||
                          selectedLeaveTypeName === "Evening HalfDay"
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Reason</label>
                      <textarea
                        name="Reason"
                        value={leaveRequestData.Reason || ""}
                        onChange={handleChange}
                        placeholder="Enter leave reason"
                        className="form-control"
                        rows="3"
                      />
                    </div>
                    {pendingleave.some(
                      (el) =>
                        el.TypeId === leaveRequestData.LeaveTypeId &&
                        el.LeaveTypeName === "Sick"
                    ) && (
                      <div className="form-group flex col-span-12 flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Upload Medical Certificate
                        </label>
                        <input
                          className="block w-full text-sm text-gray-500
        file:mr-4 file:py-2 file:px-4
        file:rounded-md file:border-0
        file:text-sm file:font-semibold
        file:bg-blue-50 file:text-blue-700
        hover:file:bg-blue-100"
                          type="file"
                          name="Medical"
                          onChange={handleFileChange}
                          accept=".pdf,.jpg,.jpeg,.png"
                        />
                        <p className="mt-1 text-xs text-gray-500">
                          PDF, JPG, JPEG, PNG (Max. 5MB)
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={() => {
                      setLeaveRequestData({});
                    }}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
            onClick={() => setAddLeaveRequestModal(false)}
          ></div>
        </>
      )}

      {editLeaveModal && (
        <form onSubmit={handleEdit}>
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm">
            <div className="fixed inset-0  bg-black/30 backdrop-blur-sm z-[5] p-15 w-full max-w-[600px] left-[50%] top-[39%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  {" "}
                  Edit Leave Request
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      onClick={() => {
                        clearLeaveRequestData();
                        seteditLeaveModal(false);
                      }}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>

                <div className="text-center ">
                  <span className="font-medium text-red-500 text-sm">
                    Pending Leaves
                  </span>
                  <hr className="   w-1/2 mx-auto" />
                </div>

                <div className="flex  gap-6 justify-center w-full">
                  {pendingleave
                    .filter((el) => {
                      const name = el.LeaveTypeName.trim().toLowerCase();
                      return ![
                        "absent",
                        "morning halfday",
                        "evening halfday",
                        "weekly off",
                        "week off",
                      ].includes(name);
                    })
                    .map((el, index) => (
                      <div
                        key={index}
                        className="p-3 rounded-lg shadow-sm flex flex-col items-center w-48 sm:w-72 md:w-80 lg:w-96 h-25 text-center"
                      >
                        <div className="font-semibold text-gray-800 ">
                          {el.LeaveTypeName}
                        </div>
                        <div className="mt-2">
                          <span className="text-gray-600 ">
                            {el.Pending}/{el.NoOfLeaves}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="my-10 md:px-10 px-[9px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    {isAdmina == 1 && (
                      <div className="form-group flex col-span-12 flex-col">
                        <label>Select Department</label>
                        <select
                          name="DepartmentId"
                          value={leaveRequestData.DepartmentId || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select department</option>
                          {department.map((el) => (
                            <option key={el.Id} value={el.Id}>
                              {el.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Employee</label>
                      <Select
                        options={empOptionForLeave}
                        value={{
                          value: leaveRequestData.EmpId,
                          label: leaveRequestData.EmpName,
                        }}
                        onChange={handleChangeSelect}
                      />
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Leave Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        name="LeaveType"
                        value={leaveTypeName.find(
                          (option) =>
                            option.value === leaveRequestData.LeaveTypeId
                        )}
                        onChange={handleChangeSelectLeave}
                        required
                        options={leaveTypeName}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group flex col-span-6 flex-col">
                      <label>
                        From Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        name="FromDate"
                        value={leaveRequestData.FromDate || ""}
                        onChange={handleChange}
                        required
                        disabled={isWeeklyOffDisabled}
                        className="form-control"
                        min={(() => {
                          const admin = Number(isAdmina); // 🔥 normalize

                          // ✅ Admin → ONLY weekly off logic
                          if (admin === 1) {
                            return selectedLeaveTypeName === "Weekly Off"
                              ? getWeeklyOffMinDate()
                              : getTodayDate();
                          }

                          // ❌ Non-admin → backdate + weekly off
                          const back2 = getTwoDaysBackDate();

                          const weeklyOffMin =
                            selectedLeaveTypeName === "Weekly Off"
                              ? getWeeklyOffMinDate()
                              : getTodayDate();

                          // pick stricter date
                          return back2 > weeklyOffMin ? back2 : weeklyOffMin;
                        })()}
                      />

                      {isWeeklyOffDisabled && (
                        <span className="text-red-600 text-sm mt-1">
                          Approval Pending on{" "}
                          {lastWeekOff.PendingDate
                            ? formatDate(lastWeekOff.PendingDate)
                            : "previous approval"}
                        </span>
                      )}

                      {console.log(lastWeekOff.PendingDate, "adasdas")}
                      {/* Error message */}
                      {isWeeklyOffDisabled && (
                        <span className="text-red-600 text-sm mt-1">
                          Approval Pending on{" "}
                          {lastWeekOff.PendingDate
                            ? formatDate(lastWeekOff.PendingDate)
                            : "previous approval"}
                        </span>
                      )}
                    </div>

                    {selectedLeaveTypeName !== "Weekly Off" &&
                      selectedLeaveTypeName !== "Morning HalfDay" &&
                      selectedLeaveTypeName !== "Evening HalfDay" && (
                        <div className="form-group flex col-span-6 flex-col">
                          <label>
                            To Date <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="date"
                            name="ToDate"
                            value={leaveRequestData.ToDate || ""}
                            onChange={handleChange}
                            required
                            min={leaveRequestData.FromDate}
                            className="form-control"
                          />
                        </div>
                      )}

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Number of Days</label>
                      <input
                        type="number"
                        name="NoOfDays"
                        value={leaveRequestData.NoOfDays || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || Number(value) >= 0) {
                            handleChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "e" ||
                            selectedLeaveTypeName === "Weekly Off" ||
                            selectedLeaveTypeName === "Morning HalfDay" ||
                            selectedLeaveTypeName === "Evening HalfDay"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        required
                        className="form-control"
                        readOnly={
                          selectedLeaveTypeName === "Weekly Off" ||
                          selectedLeaveTypeName === "Morning HalfDay" ||
                          selectedLeaveTypeName === "Evening HalfDay"
                        }
                      />
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Reason</label>
                      <textarea
                        name="Reason"
                        value={leaveRequestData.Reason || ""}
                        onChange={handleChange}
                        placeholder="Enter leave reason"
                        className="form-control"
                        rows="3"
                      />
                    </div>

                    {pendingleave.some(
                      (el) =>
                        el.TypeId === leaveRequestData.LeaveTypeId &&
                        el.LeaveTypeName === "Sick"
                    ) && (
                      <div className="form-group flex col-span-12 flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Upload Medical Certificate
                        </label>
                        {leaveRequestData.Medical && (
                          <div className="mb-2">
                            <a
                              href={`${IMAGE_URL}/${leaveRequestData.Medical}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className=""
                            >
                              <p style={{ color: "blue" }}>
                                {" "}
                                Click here to view Current Medical Certificate
                              </p>
                            </a>
                          </div>
                        )}
                        <input
                          className="block w-full text-sm text-gray-500
        file:mr-4 file:py-2 file:px-4
        file:rounded-md file:border-0
        file:text-sm file:font-semibold
        file:bg-blue-50 file:text-blue-700
        hover:file:bg-blue-100"
                          type="file"
                          name="Medical"
                          onChange={handleFileChange}
                          accept=".pdf,.jpg,.jpeg,.png"
                        />
                        <p className="mt-1 text-xs text-gray-500">
                          PDF, JPG, JPEG, PNG (Max. 5MB)
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      {/* Approve Modal */}
      {approveModal && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-[3px] z-50">
          <form onSubmit={handleStatusChange}>
            <div className="fixed inset-0 z-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg shadow-xl w-96">
                <h2 className="text-xl mb-4">Approve Leave Request</h2>

                {/* Remarks Textarea */}
                <textarea
                  className="w-full p-2 border rounded mb-4"
                  placeholder="Approval Remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  rows="4"
                  required
                />

                {/* No of Days Leave Display */}
                <p className="mb-4">
                  No Of Days Leave
                  {/* {calculateMaxDays(selectedRequest.FromDate, selectedRequest.ToDate)} */}
                </p>

                {/* Input for No of Days */}
                <input
                  className="w-full p-2 border rounded mb-4"
                  name="NoOfDays"
                  type="number"
                  disabled={
                    selectedRequest.LeaveTypeName == "Weekly Off" ||
                    selectedRequest.LeaveTypeName == "Morning HalfDay" ||
                    selectedRequest.LeaveTypeName == "Evening HalfDay"
                  }
                  value={NoofDays}
                  onChange={(e) => {
                    const value = Math.max(
                      Math.min(
                        e.target.value,
                        calculateMaxDays(
                          selectedRequest.FromDate,
                          selectedRequest.ToDate
                        )
                      ),
                      1
                    );
                    setNoofDays(value);
                  }}
                  min={1}
                  max={calculateMaxDays(
                    selectedRequest.FromDate,
                    selectedRequest.ToDate
                  )}
                  required
                />

                {/* Action Buttons */}
                <div className="flex justify-end space-x-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setApproveModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => handleStatusChange(e, 1, selectedRequest)}
                    className="btn btn-success"
                    disabled={
                      NoofDays >
                      calculateMaxDays(
                        selectedRequest.FromDate,
                        selectedRequest.ToDate
                      )
                    }
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}

      {/* Reject Modal */}
      {rejectModal && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-[3px] z-50">
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default form submission behavior
              handleStatusChange(e, 2, selectedRequest); // Pass the status and handle logic here
            }}
          >
            <div className="fixed inset-0 z-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg shadow-xl w-96">
                <h2 className="text-xl mb-4">Reject Leave Request</h2>
                <textarea
                  className="w-full p-2 border rounded mb-4"
                  placeholder="Rejection Remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  rows="4"
                  required
                />
                <div className="flex justify-end space-x-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setRejectModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-danger">
                    Reject
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default LeaveRequest;
